export const URGENCY_THRESHOLDS = {
  CRITICAL: 15,
  WARNING: 30,
  NORMAL: 60,
} as const;

export type UrgencyTier = 'gray' | 'green' | 'yellow' | 'red';

export const URGENCY_TIER_MAP: { maxDays: number; tier: UrgencyTier }[] = [
  { maxDays: URGENCY_THRESHOLDS.CRITICAL, tier: 'red' },
  { maxDays: URGENCY_THRESHOLDS.WARNING, tier: 'yellow' },
  { maxDays: URGENCY_THRESHOLDS.NORMAL, tier: 'green' },
];

export function getUrgencyTier(daysUntilDue: number): UrgencyTier {
  if (daysUntilDue < URGENCY_THRESHOLDS.CRITICAL) return 'red';
  if (daysUntilDue < URGENCY_THRESHOLDS.WARNING) return 'yellow';
  if (daysUntilDue <= URGENCY_THRESHOLDS.NORMAL) return 'green';
  return 'gray';
}

export function formatDaysUntilDue(days: number): string {
  if (days < 0) return `${Math.abs(days)} days overdue`;
  if (days === 0) return 'Due today';
  if (days === 1) return '1 day';
  return `${days} days`;
}
